import React from 'react';
import styled from 'astroturf/react';

import type { ArmSpec } from '../armRegistry';

const ScopeLine = styled.p`
  max-width: 340px;
  margin: var(--spacing-xxs-8, 8px) auto 0;
  font-family: var(--type-font-family-sans-serif, 'DM Sans', sans-serif);
  font-size: 14px;
  line-height: 1.4;
  color: var(--text-primary, #26262b);
  text-align: center;
`;

// Fear-phrased on purpose: leads with what is never accessed, never an
// exhaustive "only ..." claim (Facebook scope is broader than name+email).
const DATA_SCOPE_COPY =
  'Never your contacts, files, or inbox. Just your name and email.';

const DataScopeLine: React.FC = () => <ScopeLine>{DATA_SCOPE_COPY}</ScopeLine>;

export const dataScopeSpec: ArmSpec = {
  slots: () => ({ underCta: <DataScopeLine /> }),
};
